import { MyActiveOrganization, MyUser } from '@/helpers/my-account-helper'

export const localStorageService = {
  setItem(name, item) {
    const userStorageObject = this.getUserStorage()
    userStorageObject[MyActiveOrganization.id][name] = item
    localStorage.setItem(MyUser.id, JSON.stringify(userStorageObject))
  },

  getItem(name) {
    const userStorageObject = this.getUserStorage()
    let element = userStorageObject[MyActiveOrganization.id][name]
    if (element && element.expiry && new Date().getTime() > element.expiry) {
      localStorage.removeItem(name)
      return null
    }
    return element
  },

  setItemWithExpiration(name, item, ttl) {
    const userStorageObject = this.getUserStorage()
    userStorageObject[MyActiveOrganization.id][name] = {
      value: item,
      expiry: new Date().getTime() + ttl
    }
    localStorage.setItem(MyUser.id, JSON.stringify(userStorageObject))
  },

  getUserStorage() {
    const userStorage = localStorage.getItem(MyUser.id)
    let userStorageObject
    if (!userStorage) {
      userStorageObject = {}
    } else {
      userStorageObject = JSON.parse(userStorage)
    }
    if (!userStorageObject[MyActiveOrganization.id]) {
      userStorageObject[MyActiveOrganization.id] = {}
    }
    return userStorageObject
  }
}
